import { bool, node, number, object } from "prop-types";

import styled from "styled-components";

import FnrTypography from "FnrTypography";
import { AnimatePresence, motion } from "framer-motion";

import FnrHelpEmailLink from "UI/FnrHelpEmailLink/FnrHelpEmailLink";
import FnrWarningBox from "UI/FnrWarningBox";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";
import { explode, inOutMotion } from "UI/motionStyles";

const SFnrWarningBox = styled(FnrWarningBox)`
  margin: ${({ $marginY, $marginX }) => `${$marginY}px ${$marginX}px`};
`;

const TypographyRelay = ({ children, ...rest }) => {
  if (typeof children === "string")
    return (
      <FnrTypography color="textWarning" {...rest}>
        {children}
      </FnrTypography>
    );
  return children;
};

TypographyRelay.propTypes = {
  children: node,
};

const FnrSimpleError = ({
  show,
  marginY = 16,
  marginX = 0,
  children,
  typographyProps,
  helpLink,
  ...rest
}) => {
  if (!children) return null;
  const explodeIt = 0.1 > Math.random();

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          {...(explodeIt ? explode : inOutMotion)}
          exit={inOutMotion.exit}
        >
          <SFnrWarningBox $marginY={marginY} $marginX={marginX} {...rest}>
            <FnrVerticalGap>
              <TypographyRelay {...typographyProps}>{children}</TypographyRelay>
              {helpLink && (
                <FnrTypography color="textWarning">
                  Please try again or reach out to <FnrHelpEmailLink />
                </FnrTypography>
              )}
            </FnrVerticalGap>
          </SFnrWarningBox>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

FnrSimpleError.propTypes = {
  show: bool,
  marginY: number,
  marginX: number,
  children: node,
  typographyProps: object,
  helpLink: bool,
};

export default FnrSimpleError;
